export const calculateOrderSuccessRate = (delivered, total) => {
  const deliveredCount = Number(delivered) || 0;
  const totalCount = Number(total) || 0;

  if (totalCount <= 0) {
    return 0;
  }

  return Math.round((deliveredCount / totalCount) * 1000) / 10;
};
